import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/WebstormProjects/H5_post_plate/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// import MainButton from '@/component_basics/MainButton';
// import BaseTip from '@/component_basics/BaseTip';
import 'vant/lib/index.css';
import Verify from '@/component_basics/verifition/Verify';
import { Toast } from 'vant';
import { getQueryStringArgs } from '@/utils/index';
import VnpKeyboard from '@/component_modules/vant-number-plate/vnp-keyboard.vue';
import successIcon from '@/assets/images/success.png';
import { areaList } from '@/component_basics/area-data/list/data';
var cities = ['银川市', '吴忠市', '中卫市', '固原市', '石嘴山市'];
var params = {
  // s_addr: '银川市通达南街金瑞路车管所',
  // s_name: '车管所',
  s_phone: '09513918038',
  s_mobile: '09513918038'
};
var COMPANY_MAP = {
  'jlqc': {
    company: '银川市婕联汽车销售服务有限公司',
    city: '银川市',
    addr: '宁夏回族自治区银川市贺兰县德成路2-3号'
  }
};
export default {
  name: 'page-hello',
  components: {
    VnpKeyboard: VnpKeyboard,
    Verify: Verify
  },
  data: function data() {
    return {
      // 表单项
      sendCity: '',
      p_company: '',
      username: '',
      telephone: '',
      vehicleCode: '宁',
      itemDetail: '',
      address: '',
      company: '',
      phone: '',
      vehicleType: '',
      uuid: '',
      fee: 0,
      s_addr: '',
      // 显示隐藏标志
      showAreaPicker: false,
      showVehiclePicker: false,
      showCaptcha: false,
      showCodeInput: false,
      showSendCityPicker: false,
      showSendSitePicker: false,
      companyDisabled: false,
      // 提交参数
      params: {},
      // 从url获取参数
      urlParams: {},
      // 图标
      successIcon: successIcon,
      // 选择器列
      // areaColumns: [{ values: Object.keys(cities) }, { values: cities['浙江'] }],
      vehicleColumns: [{
        values: ['大型车辆黄牌', '大型车辆能源车牌', '拖挂车辆黄牌', '摩托车车牌', '小型车辆蓝牌', '小型车辆能源车牌', '轻便摩托车车牌']
      }],
      address_p: '',
      sendSiteList: [],
      areaList: areaList,
      cities: cities
    };
  },
  watch: {
    vehicleCode: function vehicleCode(value) {
      if (this.vehicleType.indexOf('挂') !== -1 && this.vehicleCode.indexOf('挂') === -1) {
        this.vehicleCode[6] = '挂';
      }
    }
  },
  mounted: function mounted() {
    this.urlParams = getQueryStringArgs();
    if (this.urlParams.name === 'jlqc') {
      this.companyDisabled = true;
      this.sendCity = COMPANY_MAP['jlqc'].city;
      this.p_company = COMPANY_MAP['jlqc'].company;
      this.params.s_name = this.p_company;
      this.s_addr = COMPANY_MAP['jlqc'].addr;
    }
  },
  methods: {
    // onChangeArea(picker, values) {
    //   picker.setColumnValues(1, cities[values[0]]);
    // },
    onAreaConfirm: function onAreaConfirm(value) {
      var add = '';
      value.forEach(function (v) {
        if (add !== v.name) {
          add += v.name;
        }
      });
      this.address_p = add;
      this.countFee();
      // console.log('this.address_p: ', this.address_p.indexOf('宁夏'));
      this.showAreaPicker = false;
    },
    // 计算费用
    countFee: function countFee() {
      var feeOutNingxia = 35;
      var feeOutYinchuan = 30;
      var feeInYinchuan = 25;
      if (this.vehicleType === '小型车辆蓝牌' || this.vehicleType === '小型车辆能源车牌') {
        feeOutNingxia = 25;
        feeOutYinchuan = 20;
        feeInYinchuan = 15;
      }
      if (this.address_p.indexOf('宁夏') !== -1) {
        if (this.address_p.indexOf('银川') !== -1) {
          this.fee = feeInYinchuan;
        } else {
          this.fee = feeOutYinchuan;
        }
      } else {
        this.fee = feeOutNingxia;
      }
    },
    validator: function validator(val) {
      return val && val.length !== 0;
    },
    onSendCityConfirm: function onSendCityConfirm(value) {
      // console.log('value: ', value);
      this.sendCity = value;
      this.getSite(value);
      this.showSendCityPicker = false;
    },
    onSendSiteConfirm: function onSendSiteConfirm(value) {
      // console.log('value: ', value);
      this.p_company = value.org_name;
      this.s_addr = value.org_addr;
      this.showSendSitePicker = false;
    },
    onVehicleConfirm: function onVehicleConfirm(value) {
      this.vehicleType = JSON.parse(JSON.stringify(value[0]));
      if (this.vehicleType.indexOf('挂') !== -1) {
        this.vehicleCode = '宁' + ' ' + ' ' + ' ' + ' ' + ' ' + '挂';
      } else {
        this.vehicleCode = '宁';
      }
      this.countFee();
      this.showVehiclePicker = false;
    },
    getCaptcha: function getCaptcha(values) {
      // console.log('this.urlParams: ', this.urlParams);
      if (this.vehicleCode.length !== 7 && this.vehicleCode.length !== 8 || this.vehicleCode.substr(1, 1) !== 'A' && this.vehicleCode.substr(1, 1) !== 'B' && this.vehicleCode.substr(1, 1) !== 'C' && this.vehicleCode.substr(1, 1) !== 'D' && this.vehicleCode.substr(1, 1) !== 'E') {
        Toast.fail('车牌号格式有误！');
        return;
      }
      // if (!this.urlParams.p_company) {
      //   Toast.fail('缺少二维码参数！')
      //   return
      // }
      // if (this.urlParams.p_company !== 'A' && this.urlParams.p_company !== 'B') {
      //   Toast.fail('二维码参数有误！')
      //   // eslint-disable-next-line no-useless-return
      //   return
      // }
      if (this.s_addr.length === 0 || this.p_company.length === 0) {
        Toast.fail('请填写发件信息！');
        return;
      }
      this.params = values;
      this.params.s_name = this.p_company;
      this.$refs.verify.show();
    },
    onShowInput: function onShowInput() {
      if (this.vehicleType.length === 0) {
        Toast.fail('请选择车辆类型');
      } else {
        this.showCodeInput = true;
      }
    },
    getSite: function getSite(city) {
      var _this = this;
      this.$services.getSite({
        method: 'post',
        // 默认
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        data: {
          org_city: city,
          org_type: 0 // 0：到付 1：寄付
        }
      }).then(function (res) {
        // console.log('res: ', res);
        if (res.code === 500 && res.msg) {
          Toast.fail(res.msg);
          // Notify({ type: 'danger', message: res.msg });
        } else if (res.code === 200 && res.msg) {
          _this.sendSiteList = res.data;
        }
      }).finally(function () {});
    },
    captchaSuccess: function captchaSuccess(_ref) {
      var _this2 = this;
      var captchaVerification = _ref.captchaVerification;
      this.$services.addVehicleInfo({
        method: 'post',
        // 默认
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        data: _objectSpread(_objectSpread(_objectSpread({}, params), this.params), {}, {
          s_addr: this.s_addr,
          code: captchaVerification
        })
      }).then(function (res) {
        if (res.code === 500 && res.msg) {
          Toast.fail(res.msg);
          // Notify({ type: 'danger', message: res.msg });
        } else if (res.code === 200 && res.msg) {
          Toast.success('提交成功！');
          _this2.goSuccess();
        }
      }).finally(function () {});
    },
    goSuccess: function goSuccess() {
      this.$router.push({
        path: '/success'
      });
    }
  }
};